module.exports = __webpack_public_path__ + "img/kp.8d3e7fb2.svg";